import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import MainData from "./MainData";
import ViewContainers from "./ViewContainers";
import ViewIslands from "./ViewIslands";
import FormDataContainerManager from "./container/formDataContainerManager";
import FormDataIsland from "./islands/FormDataIsland";
import UnloadsContainer from "./container/UnloadsContainer";
import ViewUnloads from "./ViewUnloads";

// prettier-ignore
const RoutesDataViews = () => {

        return (
                <>
                        <Route path="data-view" element={<PrivateRoute role="tech"><MainData /></PrivateRoute>} />
                        < Route path="data-view/containers"
                                element={< PrivateRoute role="tech"><ViewContainers /></PrivateRoute>} />
                        {/* < Route path="data-view/routes"
                                element={< PrivateRoute role="superuser"><ViewRoutes /></PrivateRoute>} /> */}
                        < Route path="data-view/data-container/:uid"
                                element={< PrivateRoute role="tech"><FormDataContainerManager /></PrivateRoute>} />
                        < Route path="data-view/data-container/unloads/:uid"
                                element={< PrivateRoute role="tech" panelType="w"><UnloadsContainer /></PrivateRoute>} />
                        < Route path="data-view/islands"
                                element={< PrivateRoute role="tech" panelType="w"><ViewIslands /></PrivateRoute>} />
                        < Route path="data-view/island/:id"
                                element={< PrivateRoute role="tech" panelType="w"><FormDataIsland /></PrivateRoute>} />
                        < Route path="data-view/unloads"
                                element={< PrivateRoute role="admin" panelType="w"><ViewUnloads /></PrivateRoute>} />
                </>
        )
}
export default RoutesDataViews;
